import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/tracks')({
  beforeLoad: () => {
    throw redirect({ to: '/certifications', replace: true });
  },
})
